export default () => {
    return 'https://ms-nexmovideo-prod.digitalk.com.br'
}